// Lib
import { Action, handleActions } from 'redux-actions';

// Actions
import { SetRedirectControl } from '@actions/redirectControl';

type RedirectControlState = string | null;

type SetRedirectControlAction = Action<string | null>;

export default handleActions<RedirectControlState, string | null>(
  {
    [SetRedirectControl.toString()]: (
      _: RedirectControlState,
      { payload }: SetRedirectControlAction,
    ): RedirectControlState => payload ?? null,
  },
  null,
);
